import type { ReactNode } from 'react'

export type PaymentMethodSelectableRowProps = {
  showBorderBelow?: boolean
  children: ReactNode
}

/** Padded container for one payment method row, with optional bottom divider. */
export function PaymentMethodSelectableRow({
  showBorderBelow = false,
  children,
}: PaymentMethodSelectableRowProps) {
  return (
    <div className={`py-4 px-5 bg-white ${showBorderBelow ? 'border-b border-grey60' : ''}`}>
      {children}
    </div>
  )
}
